var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header__content"},[_c('router-link',{staticClass:"header__logo",attrs:{"to":"/"}},[_vm._v("YT"),_c('span',[_vm._v("client")])]),_c('SearchBar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }